function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.07446 22.9916L19.9551 7.11098L29.1831 16.3389L13.3024 32.2196L4.07446 22.9916Z",
  fill: "#ECECEC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8405 22.458C16.3885 25.0059 16.3885 29.137 13.8405 31.685C11.2926 34.233 7.16149 34.233 4.61352 31.685C2.06554 29.137 2.06554 25.0059 4.61352 22.458C7.16149 19.91 11.2926 19.91 13.8405 22.458Z",
  fill: "#410BF6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.1816 7.11176C31.7296 9.65974 31.7296 13.7908 29.1816 16.3388C26.6336 18.8868 22.5026 18.8868 19.9546 16.3388C17.4066 13.7908 17.4066 9.65974 19.9546 7.11176C22.5026 4.56379 26.6336 4.56379 29.1816 7.11176Z",
  fill: "#8EE267"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 39,
    viewBox: "0 0 34 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7f949814.svg";
export { ForwardRef as ReactComponent };